"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _FeedbackSDK_instances, _FeedbackSDK_auth, _FeedbackSDK_rawFormData, _FeedbackSDK_formData, _FeedbackSDK_contactData, _FeedbackSDK_answeredPolls, _FeedbackSDK_userContext, _FeedbackSDK_debug, _FeedbackSDK_stores, _FeedbackSDK_headers, _FeedbackSDK_baseUrl, _FeedbackSDK_externalId, _FeedbackSDK_request, _FeedbackSDK_canAuth_get;
Object.defineProperty(exports, "__esModule", { value: true });
const { isEqual } = require('lodash');
const EventEmitter_1 = __importDefault(require("./EventEmitter"));
const FeedbackInstance_1 = __importDefault(require("./FeedbackInstance"));
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const core_1 = require("./utils/core");
const constants_1 = require("./constants");
const urRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
class FeedbackSDK extends EventEmitter_1.default {
    constructor({ auth, request } = {}) {
        super();
        _FeedbackSDK_instances.add(this);
        _FeedbackSDK_auth.set(this, undefined);
        _FeedbackSDK_rawFormData.set(this, undefined);
        _FeedbackSDK_formData.set(this, undefined);
        _FeedbackSDK_contactData.set(this, undefined);
        _FeedbackSDK_answeredPolls.set(this, []);
        _FeedbackSDK_userContext.set(this, {});
        _FeedbackSDK_debug.set(this, false);
        _FeedbackSDK_stores.set(this, undefined);
        this.language = 'es';
        _FeedbackSDK_headers.set(this, {});
        _FeedbackSDK_baseUrl.set(this, 'https://prod-api.smileweb.net/');
        _FeedbackSDK_externalId.set(this, undefined);
        _FeedbackSDK_request.set(this, (url, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const res = yield (0, cross_fetch_1.default)(url, options);
            return res.json();
        }));
        if (request) {
            __classPrivateFieldSet(this, _FeedbackSDK_request, request, "f");
        }
        if (auth) {
            this.authorize(auth);
        }
    }
    reset() {
        __classPrivateFieldSet(this, _FeedbackSDK_userContext, {}, "f");
        __classPrivateFieldSet(this, _FeedbackSDK_answeredPolls, [], "f");
        __classPrivateFieldSet(this, _FeedbackSDK_contactData, undefined, "f");
        __classPrivateFieldSet(this, _FeedbackSDK_formData, undefined, "f");
        __classPrivateFieldSet(this, _FeedbackSDK_rawFormData, undefined, "f");
        __classPrivateFieldSet(this, _FeedbackSDK_auth, undefined, "f");
        this.off();
    }
    get userContext() {
        return __classPrivateFieldGet(this, _FeedbackSDK_userContext, "f");
    }
    appendUserContext(data) {
        Object.assign(__classPrivateFieldGet(this, _FeedbackSDK_userContext, "f"), data !== null && data !== void 0 ? data : {});
    }
    get auth() {
        var _a;
        return (_a = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) !== null && _a !== void 0 ? _a : {};
    }
    set debug(value) {
        __classPrivateFieldSet(this, _FeedbackSDK_debug, value, "f");
        this.log({
            message: 'DEBUG enabled.',
        });
    }
    log(payload) {
        if (!__classPrivateFieldGet(this, _FeedbackSDK_debug, "f"))
            return;
        this.emit('log', payload);
    }
    set headers(value) {
        __classPrivateFieldSet(this, _FeedbackSDK_headers, value, "f");
    }
    get headers() {
        return __classPrivateFieldGet(this, _FeedbackSDK_headers, "f");
    }
    setHeader(key, value) {
        __classPrivateFieldSet(this, _FeedbackSDK_headers, Object.assign(Object.assign({}, __classPrivateFieldGet(this, _FeedbackSDK_headers, "f")), { [key]: value }), "f");
    }
    get debug() {
        return __classPrivateFieldGet(this, _FeedbackSDK_debug, "f");
    }
    set auth(auth) {
        if (isEqual(auth, __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")))
            return;
        __classPrivateFieldSet(this, _FeedbackSDK_auth, auth, "f");
    }
    authorize(auth) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            if (isEqual(auth, __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")))
                return { raw: (_a = __classPrivateFieldGet(this, _FeedbackSDK_rawFormData, "f")) !== null && _a !== void 0 ? _a : {}, parsed: (_b = __classPrivateFieldGet(this, _FeedbackSDK_formData, "f")) !== null && _b !== void 0 ? _b : {} };
            __classPrivateFieldSet(this, _FeedbackSDK_auth, auth, "f");
            try {
                if (!((_c = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _c === void 0 ? void 0 : _c.hash) && !((_d = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _d === void 0 ? void 0 : _d.token))
                    return null;
                this.emit('form-data', { loading: true });
                const raw = yield this.request({
                    path: `v1/form-data/${(_f = (_e = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _e === void 0 ? void 0 : _e.hash) !== null && _f !== void 0 ? _f : ''}?${new URLSearchParams(__classPrivateFieldGet(this, _FeedbackSDK_userContext, "f").query)}`,
                });
                return this.parseRawFormData(raw.data);
            }
            catch (error) {
                this.emit('form-data', { error, loading: false });
                return null;
            }
        });
    }
    parseRawFormData(rawFormData) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldSet(this, _FeedbackSDK_rawFormData, rawFormData, "f");
            __classPrivateFieldSet(this, _FeedbackSDK_formData, (0, core_1.parseFormData)(rawFormData), "f");
            this.emit('form-data', { raw: rawFormData, payload: __classPrivateFieldGet(this, _FeedbackSDK_formData, "f"), loading: false });
            return { raw: rawFormData, parsed: (_a = __classPrivateFieldGet(this, _FeedbackSDK_formData, "f")) !== null && _a !== void 0 ? _a : {} };
        });
    }
    getStores() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (__classPrivateFieldGet(this, _FeedbackSDK_stores, "f"))
                    return __classPrivateFieldGet(this, _FeedbackSDK_stores, "f");
                const raw = yield this.request({
                    path: `form-data${((_a = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _a === void 0 ? void 0 : _a.hash) ? '/' + ((_b = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _b === void 0 ? void 0 : _b.hash) : ''}/stores`,
                });
                __classPrivateFieldSet(this, _FeedbackSDK_stores, raw, "f");
                this.emit('stores', __classPrivateFieldGet(this, _FeedbackSDK_stores, "f"));
                return __classPrivateFieldGet(this, _FeedbackSDK_stores, "f");
            }
            catch (error) {
                return null;
            }
        });
    }
    requestContactData() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.log(['contact-data', __classPrivateFieldGet(this, _FeedbackSDK_externalId, "f"), __classPrivateFieldGet(this, _FeedbackSDK_instances, "a", _FeedbackSDK_canAuth_get)]);
                if (!__classPrivateFieldGet(this, _FeedbackSDK_instances, "a", _FeedbackSDK_canAuth_get))
                    return;
                if (__classPrivateFieldGet(this, _FeedbackSDK_externalId, "f")) {
                    const json = yield this.request({
                        path: `contact-data/${__classPrivateFieldGet(this, _FeedbackSDK_externalId, "f")}`,
                    });
                    __classPrivateFieldSet(this, _FeedbackSDK_contactData, json, "f");
                }
                else {
                    __classPrivateFieldSet(this, _FeedbackSDK_contactData, {}, "f");
                }
                this.emit('contact-data', __classPrivateFieldGet(this, _FeedbackSDK_contactData, "f"));
                return __classPrivateFieldGet(this, _FeedbackSDK_contactData, "f");
            }
            catch (error) {
                this.emit('contact-data', undefined, error);
                return null;
            }
        });
    }
    set externalId(externalId) {
        __classPrivateFieldSet(this, _FeedbackSDK_externalId, externalId, "f");
        this.emit('external-id', __classPrivateFieldGet(this, _FeedbackSDK_externalId, "f"));
        this.requestContactData();
    }
    createFeedbackInstance(params = {}) {
        this.log(['createFeedbackInstance', params]);
        return new FeedbackInstance_1.default(this, params);
    }
    get externalId() {
        return __classPrivateFieldGet(this, _FeedbackSDK_externalId, "f");
    }
    get formData() {
        return __classPrivateFieldGet(this, _FeedbackSDK_formData, "f");
    }
    get contactData() {
        return __classPrivateFieldGet(this, _FeedbackSDK_contactData, "f");
    }
    get answeredPolls() {
        return __classPrivateFieldGet(this, _FeedbackSDK_answeredPolls, "f");
    }
    pushToAnsweredPolls(pollId) {
        __classPrivateFieldGet(this, _FeedbackSDK_answeredPolls, "f").push(pollId);
        this.emit('answered-polls');
    }
    get baseUrl() {
        return __classPrivateFieldGet(this, _FeedbackSDK_baseUrl, "f");
    }
    set baseUrl(value) {
        if (!urRegex.test(value))
            return;
        __classPrivateFieldSet(this, _FeedbackSDK_baseUrl, value.substr(-1) === '/' ? value : `${value}/`, "f");
    }
    request(_a) {
        var _b, _c;
        var { path, useAuth = true } = _a, rest = __rest(_a, ["path", "useAuth"]);
        return __awaiter(this, void 0, void 0, function* () {
            const headers = Object.assign(Object.assign(Object.assign({}, __classPrivateFieldGet(this, _FeedbackSDK_headers, "f")), (useAuth && !((_b = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _b === void 0 ? void 0 : _b.hash)
                ? {
                    'Content-Type': 'application/json',
                    'Authorization': (_c = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _c === void 0 ? void 0 : _c.token,
                }
                : {})), rest.headers);
            return __classPrivateFieldGet(this, _FeedbackSDK_request, "f").call(this, `${__classPrivateFieldGet(this, _FeedbackSDK_baseUrl, "f")}api/${path}`, Object.assign(Object.assign({}, rest), { headers }));
        });
    }
    getDefaultPalette() {
        return constants_1.defaultInstanceSettings.ui.theme.lightPalette;
    }
}
exports.default = FeedbackSDK;
_FeedbackSDK_auth = new WeakMap(), _FeedbackSDK_rawFormData = new WeakMap(), _FeedbackSDK_formData = new WeakMap(), _FeedbackSDK_contactData = new WeakMap(), _FeedbackSDK_answeredPolls = new WeakMap(), _FeedbackSDK_userContext = new WeakMap(), _FeedbackSDK_debug = new WeakMap(), _FeedbackSDK_stores = new WeakMap(), _FeedbackSDK_headers = new WeakMap(), _FeedbackSDK_baseUrl = new WeakMap(), _FeedbackSDK_externalId = new WeakMap(), _FeedbackSDK_request = new WeakMap(), _FeedbackSDK_instances = new WeakSet(), _FeedbackSDK_canAuth_get = function _FeedbackSDK_canAuth_get() {
    var _a, _b;
    return !!((_a = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _a === void 0 ? void 0 : _a.hash) || !!((_b = __classPrivateFieldGet(this, _FeedbackSDK_auth, "f")) === null || _b === void 0 ? void 0 : _b.token);
};
